import type { MagentoCurrency } from "@jti/magento-types";

import type { Currency } from "../../types/Currency.types";

export const fromMagentoCurrency = (magentoCurrency: MagentoCurrency): Currency => {
  const code = magentoCurrency.defaultDisplayCurrencyCode;
  const symbol = magentoCurrency.defaultDisplayCurrencySymbol;

  return { code, symbol };
};
